import { parseCalendarDate } from './helper';

// Mission dates are calendar days, not instants: the API stores duration.dateend as a
// string serialised at UTC midnight, while the DatePicker hands back a local Date carrying
// the current time of day. Comparing the two raw makes an interruption on the mission's
// own last day look "after the end" from 02:00 local onwards, so every comparison here
// runs on local midnights.
const startOfDay = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const formatDateFr = (date) => {
  if (!date) return '…';
  const d = date instanceof Date ? date : parseCalendarDate(date);
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
};

const missionEndDay = (missionDateEnd) =>
  missionDateEnd ? startOfDay(parseCalendarDate(missionDateEnd)) : null;

export const getInterruptEndDateError = ({
  endDate,
  missionDateEnd,
  isNoShow = false,
}) => {
  // A No-Show cancels or unassigns the mission outright, no end date is applied.
  if (isNoShow) return '';
  if (!endDate) return '';

  // A past date is allowed: interruptions are regularly entered after the fact,
  // once the agency learns the temp worker stopped days ago.
  const selected = startOfDay(endDate);
  const end = missionEndDay(missionDateEnd);
  if (end && selected > end)
    return `La date d'interruption ne peut pas dépasser la date de fin prévue (${formatDateFr(end)})`;

  return '';
};

/**
 * A period whose start falls after its end. The api refuses it too, and BeSTT
 * would take the contract anyway — with a term before its own start.
 */
export const getPeriodDatesError = ({ start, end }) => {
  if (!start || !end) return '';
  const first = startOfDay(start instanceof Date ? start : parseCalendarDate(start));
  const last = startOfDay(end instanceof Date ? end : parseCalendarDate(end));
  if (Number.isNaN(first.getTime()) || Number.isNaN(last.getTime())) return '';
  if (first <= last) return '';
  return `La date de début ne peut pas être postérieure à la date de fin (${formatDateFr(last)})`;
};

export const getReplacementRange = ({
  endDate,
  missionDateEnd,
  today = new Date(),
}) => {
  const end = missionEndDay(missionDateEnd);

  // The replacement covers the very day the mission stops: the client needs
  // somebody then, not the day after. An interruption entered after the fact
  // cannot staff the past, so it starts today instead — and never after the
  // term it is meant to cover.
  const interruption = startOfDay(endDate);
  const floor = startOfDay(today);
  const start = interruption < floor ? floor : interruption;

  return { start: end && start > end ? new Date(end) : start, end };
};

// Whether an interruption falls within the trial period, its last day included.
// A mission whose trial period is unknown is taken as past it: a trial ending is
// never offered on a guess.
export const isWithinTrialPeriod = ({ endDate, trialPeriodEnd }) => {
  if (!endDate || !trialPeriodEnd) return false;
  return startOfDay(endDate) <= startOfDay(parseCalendarDate(trialPeriodEnd));
};
